/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { EncryptionService } from '../../services/encryption.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService {
  platformId = inject(PLATFORM_ID);
  router = inject(Router);
  authService = inject(AuthService);
  encryptionService = inject(EncryptionService);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(
    _next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): boolean | UrlTree {
    // ✅ SSR: always allow
    if (!isPlatformBrowser(this.platformId)) {
      return true;
    }

    const isAuthenticated = this.authService.isAuthenticated();
    const profile = this.encryptionService.decryptLocalStorage('profile');
    const lang = localStorage.getItem('language') ?? 'en';

    if (!isAuthenticated) {
      localStorage.clear();
      localStorage.setItem('language', lang);
      return this.router.parseUrl('/auth/login');
    }

    if (
      profile &&
      profile.iscontract === false &&
      profile.type === 'SERVICE_PROVIDER'
    ) {
      localStorage.clear();
      localStorage.setItem('language', lang);
      return this.router.parseUrl('/auth/login');
    }

    return true;
  }
}
export const AuthGuard = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(AuthGuardService).canActivate(next, state);
};
